module.exports = __webpack_public_path__ + "img/1523343959.728fbde8.jpg";